module.exports = __webpack_public_path__ + "static/media/v14.6251805c.mp4";